// extracted by mini-css-extract-plugin
export default {"splitEventWrapper":"calComp_splitEventWrapper__KCYjm","eventDetails":"calComp_eventDetails__QbdD5","info":"calComp_info__nv7Nm","value":"calComp_value__Kjbkc"};